import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import {
  CABIN_CREW_MOVEMENT_HISTORY_PATH,
  NEW_CABIN_CREW_MOVEMENT_HISTORY_PATH,
} from '../../../../config/paths';
import {
  clearCabinCrewsMovementHistory,
  getCabinCrewsMovementHistory,
} from '../../../../actions';
import { CABIN_CREWS_MOVEMENT_HISTORY_COLUMNS } from '../../../../config/columns';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Table from '../../../common/Table';
import TableToolbar from '../../../common/TableToolbar';

export const CabinCrewsMovementHistory = ({
  dispatchGetCabinCrewsMovementHistory,
  dispatchClearCabinCrewsMovementHistory,
  loading,
  cabinCrewMovementHistoryList,
  breadcrumbs,
}) => {
  useLayoutEffect(() => () => dispatchClearCabinCrewsMovementHistory(), []);

  const data = cabinCrewMovementHistoryList.get('content') || [];
  const pages = cabinCrewMovementHistoryList.get('totalPages') || null;
  const defaultPageSize =
    cabinCrewMovementHistoryList.get('size') || DEFAULT_PAGE_SIZE;

  const toolbar = (
    <TableToolbar
      buttonPath={NEW_CABIN_CREW_MOVEMENT_HISTORY_PATH}
      buttonText="Crear"
      buttonClassName="btn btn-primary"
    />
  );

  const content = (
    <>
      <Table
        columns={CABIN_CREWS_MOVEMENT_HISTORY_COLUMNS}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        filterable
        fetchData={dispatchGetCabinCrewsMovementHistory}
        modelPath={CABIN_CREW_MOVEMENT_HISTORY_PATH}
        loading={loading}
        navigateToModelOnRowClick
      />
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Movimientos de Servicio a Bordo"
      toolbar={toolbar}
      content={content}
    />
  );
};

CabinCrewsMovementHistory.propTypes = {
  dispatchGetCabinCrewsMovementHistory: PropTypes.func.isRequired,
  dispatchClearCabinCrewsMovementHistory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  cabinCrewMovementHistoryList: PropTypes.instanceOf(Immutable.Map),
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

CabinCrewsMovementHistory.defaultProps = {
  loading: false,
  cabinCrewMovementHistoryList: null,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Movimientos de Servicio a Bordo',
      href: CABIN_CREW_MOVEMENT_HISTORY_PATH,
    },
  ],
  cabinCrewMovementHistoryList: TrafficUnit.CabinCrewMovementHistory.getIn([
    'all',
    'content',
  ]),
  loading: TrafficUnit.CabinCrewMovementHistory.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetCabinCrewsMovementHistory: getCabinCrewsMovementHistory,
  dispatchClearCabinCrewsMovementHistory: clearCabinCrewsMovementHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CabinCrewsMovementHistory);